import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import { useSelector } from "react-redux";
import Back from "features/metadesk/components/Back";
import { useOutletContext } from "react-router-dom";
import { isEmpty } from "lodash-es";
import { Loading } from "features/common";
import { apiUrl } from "features/configure";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import useNavigateEntity from "hooks/useNavigateEntity";

const IntegrationAdd = ({
  initConfig,
  config,
  fetchConfig,
  selectModule,
  contentComponent: ContentComponent,
  apiPath,
  needId,
  id,
  pageTitle,
  pageDescription,
}) => {
  const [entityName] = useOutletContext();
  const [integrityInfo, setIntegrityInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatchSnackbar = useDispatchSnackbar();

  const module = useSelector(selectModule);
  const { navigateEntity } = useNavigateEntity();

  const [configInfo, setConfigInfo] = useState(initConfig);

  // 如果setup incomplete，則來到此頁面，直接進行新增
  useEffect(() => {
    if (needId && id) {
      // config is an array
      const item = config.find((x) => x._id === id);
      setConfigInfo({ ...item, isNewAdd: false });
    } else if (config) {
      // config is an object
      setConfigInfo({ ...config, isNewAdd: false });
    }
  }, [needId, id, config]);

  const fetchIntegrity = async () => {
    try {
      const { data } = await axios.get(`${apiUrl}/api/integrity/${apiPath}`);
      setIntegrityInfo(data);
    } catch (err) {
      dispatchSnackbar({ err });
    }
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        await fetchConfig({ entityName });

        if (module && (module.connected || module.connecting)) {
          navigateEntity("/settings/general/integration/add");
          return;
        }

        fetchIntegrity();
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Box sx={{ minHeight: "calc(100vh - 110px)", position: "relative" }}>
      <div className="fade-up">
        <Back />
        <div className="lgTitle" style={{ marginTop: 18 }}>
          {pageTitle}
        </div>
        <div className="description betweenRow" style={{ lineHeight: "20px" }}>
          {pageDescription}
        </div>
      </div>
      <Loading open={loading} white={false} />
      <Box marginTop={"15px"} className="fade-up-more">
        {!isEmpty(integrityInfo) && (
          <ContentComponent
            setLoading={setLoading}
            initConfig={initConfig}
            configInfo={configInfo}
            integrityInfo={integrityInfo}
          />
        )}
      </Box>
    </Box>
  );
};

export default IntegrationAdd;
